import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { PageTransition } from "@/components/PageTransition";
import SEOAudit from "@/pages/SEOAudit";

export const Route = createFileRoute("/seo-audit/")({
  head: () => ({
    meta: [
      { title: "Free SEO Audit Tool — The Outpost" },
      {
        name: "description",
        content:
          "Scan your website's SEO health, readability, and content in 30 seconds — free. Unlock the full audit with the Get Found Playbook.",
      },
      { property: "og:title", content: "Free SEO Audit Tool — The Outpost" },
      {
        property: "og:description",
        content:
          "Scan your website's SEO health, readability, and content in 30 seconds — free.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content: "Free SEO Audit Tool — The Outpost",
      },
    ],
    links: [{ rel: "canonical", href: "https://theoutpost.agency/seo-audit" }],
  }),
  component: SEOAuditRoute,
});

function SEOAuditRoute() {
  return (
    <PageTransition>
      <Suspense fallback={<div className="min-h-screen bg-background" />}>
        <SEOAudit />
      </Suspense>
    </PageTransition>
  );
}
